import i18next from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18next
  .use(I18NextHttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['cs', 'en'],
    fallbackLng: 'cs',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    keySeparator: false,
    ns: ['admin', 'client'],
    defaultNS: 'admin',
    debug: true,
    missingKeyHandler: (_lng, ns, key, fallbackValue) => {
      console.log(`!!!Missing translation for key: ${key}, namespace: ${ns}. Fallback value: ${fallbackValue}`);
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Otisk buildu v URL — jinak prohlížeč drží starý překlad z cache a je nutný tvrdý refresh.
      loadPath: `/locales/{{lng}}/{{ns}}.json?version=${__BUILD_VERSION__}`,
    },
  });

i18next.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
